<template>
  <div class="huawei-login">
    <div class="form-box">
      <h1 class="title">
        <template v-if="operateType === 'huaweiAuth'">华为账号登录</template>
        <template v-else-if="operateType === 'pwdLogin'">登录已有账号</template>
        <template v-else-if="operateType === 'phoneLogin'">手机号登录</template>
        <template v-else-if="operateType === 'forgetPwd'">
          {{ forgetStep === 1 ? '找回密码' : '设置新密码' }}
        </template>
        <template v-else-if="operateType === 'isRegister'">
          {{ registerStep === 1 ? '创建新账号' : registerStep === 2 ? '设置密码' : '注册完成' }}
        </template>
      </h1>

      <!-- 华为授权登录入口 -->
      <div v-if="operateType === 'huaweiAuth'" class="login-form">
        <div class="huawei-logo">
          <img src="../../assets/images/mobile/user.svg" alt="华为">
        </div>

        <button
          @click="handleHuaweiLogin"
          class="button huawei-button"
          :disabled="btnLoading"
        >
          <LoadingOutlined class="icon-loading" v-show="btnLoading" />
          {{ btnLoading ? '登录中...' : '使用华为账号登录' }}
        </button>

        <div class="tips" v-if="errorMsg">
          <span class="error-text">{{ errorMsg }}</span>
        </div>
      </div>

      <!-- 密码登录（关联已有账号） -->
      <div v-if="operateType === 'pwdLogin'" class="login-form">
        <a-form
          ref="pwdLoginForm"
          :model="formState"
          :rules="rules"
        >
          <a-form-item name="username">
            <a-input v-model:value="formState.username" placeholder="请输入账号/手机号">
              <template #prefix>
                <img src="../../assets/images/Phone.svg" alt="">
              </template>
            </a-input>
          </a-form-item>

          <a-form-item name="password">
            <a-input-password v-model:value="formState.password" placeholder="请输入密码">
              <template #prefix>
                <img src="../../assets/images/password.svg" alt="">
              </template>
            </a-input-password>
          </a-form-item>

          <a-button
            @click="submitPwdLogin"
            block
            type="primary"
            :loading="btnLoading"
            style="height:50px"
          >登录并关联华为账号</a-button>
        </a-form>

        <ul class="other">
          <li class="text" @click="operateType = 'phoneLogin'">手机号登录</li>
          <li class="text" @click="operateType = 'forgetPwd'">忘记密码</li>
        </ul>
      </div>

      <!-- 手机号登录 -->
      <div v-if="operateType === 'phoneLogin'" class="login-form">
        <a-form
          ref="phoneLoginForm"
          :model="phoneState"
          :rules="phoneLoginRules"
        >
          <a-form-item name="phone">
            <a-input v-model:value="phoneState.phone" placeholder="请输入手机号">
              <template #prefix>
                <img src="../../assets/images/Phone.svg" alt="">
              </template>
            </a-input>
          </a-form-item>

          <a-form-item name="smscode">
            <a-input v-model:value="phoneState.smscode" placeholder="短信验证码">
              <template #prefix>
                <img src="../../assets/images/verify.svg" alt="">
              </template>

              <template #suffix>
                <span v-if="second.value" class="sms-code">{{second.value + 'S'}}</span>
                <span v-else @click="showNewPLVerify" class="fetch-code">发送验证码</span>
              </template>
            </a-input>
          </a-form-item>

          <a-button
            @click="submitPhoneLogin"
            block
            type="primary"
            :loading="btnLoading"
            style="height:50px"
          >登录并关联华为账号</a-button>
        </a-form>

        <ul class="other">
          <li class="text" @click="operateType = 'pwdLogin'">密码登录</li>
          <li class="text" @click="operateType = 'forgetPwd'">忘记密码</li>
        </ul>
      </div>

      <!-- 忘记密码 -->
      <div v-if="operateType === 'forgetPwd'" class="login-form">
        <a-form
          ref="forgetForm"
          :model="forgetState"
          :rules="forgetRules"
        >
          <div v-show="forgetStep === 1">
            <a-form-item name="phone">
              <a-input v-model:value="forgetState.phone" placeholder="请输入手机号">
                <template #prefix>
                  <img src="../../assets/images/Phone.svg" alt="">
                </template>
              </a-input>
            </a-form-item>

            <a-form-item name="smscode">
              <a-input v-model:value="forgetState.smscode" placeholder="短信验证码">
                <template #prefix>
                  <img src="../../assets/images/verify.svg" alt="">
                </template>

                <template #suffix>
                  <span v-if="second.value" class="sms-code">{{second.value + 'S'}}</span>
                  <span v-else @click="showNewFPVerify" class="fetch-code">发送验证码</span>
                </template>
              </a-input>
            </a-form-item>
          </div>

          <div v-if="forgetStep === 2">
            <a-form-item name="newPassword">
              <a-input-password v-model:value="forgetState.newPassword" type="password" autocomplete placeholder="设置密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>
            <a-form-item name="confirmPassword">
              <a-input-password v-model:value="forgetState.confirmPassword" type="password" autocomplete placeholder="确认密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>
          </div>

          <a-button
            v-show="forgetStep === 1"
            @click="forgetPwdNext"
            block
            type="primary"
            :loading="btnLoading"
            style="height:50px"
          >下一步</a-button>

          <a-button
            v-show="forgetStep === 2"
            @click="submitForgetPwd"
            block
            type="primary"
            :loading="btnLoading"
            style="height:50px"
          >提交</a-button>
        </a-form>

        <ul class="other">
          <li class="text" @click="operateType = 'pwdLogin'">返回登录</li>
        </ul>
      </div>

      <!-- 注册新账号 -->
      <div v-if="operateType === 'isRegister'" class="login-form">
        <!-- 第一步：输入手机号获取验证码 -->
        <div v-if="registerStep === 1">
          <a-form
            ref="registerForm"
            :model="registerState"
            :rules="registerRules"
          >
            <a-form-item name="phone">
              <a-input v-model:value="registerState.phone" placeholder="请输入手机号">
                <template #prefix>
                  <img src="../../assets/images/Phone.svg" alt="">
                </template>
              </a-input>
            </a-form-item>

            <a-form-item name="smscode">
              <a-input v-model:value="registerState.smscode" placeholder="短信验证码">
                <template #prefix>
                  <img src="../../assets/images/verify.svg" alt="">
                </template>

                <template #suffix>
                  <span v-if="second.value" class="sms-code">{{second.value + 'S'}}</span>
                  <span v-else @click="showNewVerify" class="fetch-code">发送验证码</span>
                </template>
              </a-input>
            </a-form-item>

            <a-form-item name="agreement">
              <a-checkbox v-model:checked="registerState.agreement">
                <span class="agree">已阅读并同意浩邈账号<span class="user-agree" @click.self="showRegister">《用户协议》</span><span class="agree">和</span><span class="user-agree" @click.self="showPrivacy">《隐私政策》</span></span>
              </a-checkbox>
            </a-form-item>

            <a-button
              @click="register"
              block
              type="primary"
              :disabled="registerState.phone === ''||
                registerState.smscode === ''||
                registerState.agreement === false"
              :loading="btnLoading"
              style="height:50px"
            >下一步</a-button>
          </a-form>
        </div>

        <!-- 第二步：设置密码 -->
        <div v-if="registerStep === 2">
          <a-form
            ref="registerForm"
            :model="registerState"
            :rules="registerRules"
          >
            <a-form-item name="newPassword">
              <a-input-password v-model:value="registerState.newPassword" placeholder="请设置密码（8-20位，需包含字母和数字）">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>

            <a-form-item name="confirmPassword">
              <a-input-password v-model:value="registerState.confirmPassword" placeholder="请再次输入密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>

            <a-button
              @click="setPassword"
              block
              type="primary"
              :disabled="registerState.newPassword === ''||
              registerState.confirmPassword === ''"
              :loading="btnLoading"
              style="height:50px"
            >完成注册</a-button>
          </a-form>
        </div>

        <!-- 第三步：注册完成 -->
        <div v-if="registerStep === 3" class="reg-finish">
          <div class="icon-box">
            <!-- <img class="icon" src="../../assets/images/mobile/smile.svg" alt=""> -->
          </div>
          <p class="reg-finish-tip">您的账号：{{registerState.phone}} 已成功注册！</p>
          <button @click="backLogin" class="button">立即登录</button>
          <button @click="backLogin" class="button button-plain" style="margin-top: 16px">返回首页</button>
        </div>
      </div>

    </div>

    <!-- 关联账号选择弹窗 -->
    <a-modal
      v-model:visible="relationVisible"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      width="400px"
    >
      <div class="modal-title">选择关联方式</div>
      <div class="avatar">
        <div class="pic-box">
          <img class="pic" :src="hwUserInfo.headimgurl || require('../../assets/images/mobile/user.svg')" alt="">
        </div>
        <div class="name">{{ hwUserInfo.nickname || '华为用户' }}</div>
        <div class="text">该华为账号尚未关联系统账号</div>
      </div>
      <div class="btn-box">
        <a-button type="primary" block @click="loginByAccount">登录已有账号</a-button>
        <a-button block @click="createAccount">创建新账号</a-button>
      </div>
    </a-modal>

    <!-- 关联确认弹窗 -->
    <a-modal
      v-model:visible="allocated"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      width="400px"
    >
      <div class="modal-title">确认关联</div>
      <div class="avatar">
        <div class="pic-box">
          <img class="pic" :src="hwUserInfo.headimgurl || require('../../assets/images/mobile/user.svg')" alt="">
        </div>
        <div class="name">{{ hwUserInfo.nickname || '华为用户' }}</div>
        <div class="text">是否将华为账号与当前账号关联？</div>
      </div>
      <div class="btn-box">
        <a-button type="primary" block @click="handleRelate" :loading="btnLoading">确认关联</a-button>
        <a-button block @click="cancelRelate">暂不关联，直接进入</a-button>
      </div>
    </a-modal>

    <!-- 验证码弹窗 - 注册 -->
    <Verify
      @success="reqSmsCode"
      mode="pop"
      captchaType="clickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newVerify"
      v-if="showVerity"
      :phone="registerState.phone"
    />

    <!-- 验证码弹窗 - 手机号登录 -->
    <Verify
      v-if="showPLVerity"
      @success="phoneLoginGetCode"
      mode="pop"
      captchaType="newClickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newPLVerify"
      :phone="phoneState.phone"
    />

    <!-- 验证码弹窗 - 忘记密码 -->
    <Verify
      v-if="showFPVerity"
      @success="forgetGetCode"
      mode="pop"
      captchaType="newClickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newFPVerify"
      :phone="forgetState.phone"
    />
  </div>
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { defineComponent, computed, onBeforeMount } from 'vue';
import Qs from 'qs';
import Common from '@/utils/common';
import { APP_ID, APP_SECRET, PLAT_TYPE, FROM_OS, redirectUrl } from '@/utils/constant';
import store from '@/store';
import MD5 from 'crypto-js/md5';
import Verify from '@/components/verifition/Verify';
import { phone, pwdValidate, newPassword } from '@/utils/vlidator';
import { getAgreement, showPrivacy, showRegister } from '@/utils/setup/agreement';
import { loginModule } from '@/utils/mixin';
const envJudge = require('@/utils/envJudge');

export default defineComponent({
  name: 'huaweiLogin',
  mixins: [loginModule],
  components: { LoadingOutlined, Verify },
  setup () {
    onBeforeMount(() => {
      getAgreement();
    });
    return { showPrivacy, showRegister };
  },
  data () {
    // 表单验证规则
    const phoneRule = [
      { required: true, message: '请输入手机号' },
      { pattern: /^1\d{10}$/, message: '手机号为11位有效数字' }
    ];
    const newPasswordRule = [{ validator: pwdValidate }];
    const smscode = [{ required: true, message: '请输入验证码' }];
    const agreement = [{ required: true, message: '请勾选用户协议和隐私政策' }];

    return {
      btnLoading: false,
      errorMsg: '',
      operateType: 'huaweiAuth', // huaweiAuth | pwdLogin | isRegister
      hwUserInfo: {}, // 华为用户信息
      relationVisible: false, // 显示关联选择弹窗
      allocated: false, // 显示关联确认弹窗
      relationAccount: false, // 是否正在关联账号流程
      isRegisterBindHw: 0, // 是否注册时自动关联华为
      registerStep: 1, // 注册步骤：1-手机验证 2-设置密码 3-完成
      forgetStep: 1, // 忘记密码步骤：1-手机验证 2-设置密码
      showVerity: false, // 显示注册验证码弹窗
      showPLVerity: false, // 显示手机号登录验证码弹窗
      showFPVerity: false, // 显示忘记密码验证码弹窗

      // 华为OAuth配置
      HUAWEI_CONFIG: {
        clientId: '6917586360716091664', // 华为开发者联盟申请的Client ID
        // redirectUri: 'http://account.ehaomiao.net:81/test/account/userLogin/hwCallback', // 回调地址
        redirectUri: '', // 回调地址
        scope: 'openid profile phone',
        responseType: 'code'
      },

      // 密码登录表单
      formState: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号' },
          { min: 1, max: 20, message: '账号为1-20位' }
        ],
        password: [{ required: true, message: '请输入密码' }]
      },

      // 注册表单
      registerState: {
        phone: '',
        smscode: '',
        agreement: false,
        newPassword: '',
        confirmPassword: ''
      },
      registerRules: {
        phone: phoneRule,
        smscode,
        agreement,
        newPassword: newPasswordRule,
        confirmPassword: [
          { validator: pwdValidate },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerState.newPassword) {
                callback(new Error('两次密码不一致'));
              } else {
                callback();
              }
            }
          }
        ]
      },

      // 手机号登录表单
      phoneState: {
        phone: '',
        smscode: ''
      },
      phoneLoginRules: {
        phone: phoneRule,
        smscode
      },

      // 忘记密码表单
      forgetState: {
        phone: '',
        smscode: '',
        newPassword: '',
        confirmPassword: ''
      },
      forgetRules: {
        phone: phoneRule,
        smscode,
        newPassword: newPasswordRule,
        confirmPassword: [
          { validator: pwdValidate },
          {
            validator: (rule, value, callback) => {
              if (value !== this.forgetState.newPassword) {
                callback(new Error('两次密码不一致'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  mounted () {
    // 设置页面标题
    document.title = '华为登录';

    // 检查是否为回调 - 使用 Vue Router 获取参数
    const code = this.$route.query.code;
    const state = this.$route.query.state;

    if (code) {
      this.handleCallback(code, state);
    }
  },
  methods: {
    /**
     * 华为登录 - 跳转到华为授权页面
     */
    handleHuaweiLogin () {
      try {
        this.btnLoading = true;
        this.errorMsg = '';

        // 生成state参数用于防止CSRF攻击
        const state = 'housekeeperApp-housekeeperApp';
        sessionStorage.setItem('huawei_oauth_state', state);

        // 根据当前页面动态生成 redirect_uri（去除可能存在的 code 参数）
        const search = Qs.parse(location.search, { ignoreQueryPrefix: true });
        if (Object.prototype.hasOwnProperty.call(search, 'code')) {
          delete search.code;
        }
        const query = Object.keys(search).length ? ('?' + Qs.stringify(search)) : Qs.stringify(search);
        // 固定回调路径，按环境前缀拼接：/test/ 或 /rc/ 或 /
        const redirectUri = location.origin + envJudge() + 'account/userLogin/hwCallback' + query;

        // 构建华为授权URL
        const authUrl = new URL('https://oauth-login.cloud.huawei.com/oauth2/v3/authorize');
        authUrl.searchParams.append('client_id', this.HUAWEI_CONFIG.clientId);
        authUrl.searchParams.append('redirect_uri', redirectUri);
        authUrl.searchParams.append('response_type', this.HUAWEI_CONFIG.responseType);
        authUrl.searchParams.append('scope', this.HUAWEI_CONFIG.scope);
        authUrl.searchParams.append('state', state);

        // 跳转到华为授权页面
        window.location.href = authUrl.toString();
      } catch (error) {
        console.error('华为登录失败:', error);
        this.errorMsg = '登录失败，请重试';
        this.btnLoading = false;
      }
    },

    /**
     * 处理华为OAuth回调
     */
    async handleCallback (code, state) {
      try {
        this.btnLoading = true;
        this.errorMsg = '';

        // 验证state参数
        const savedState = sessionStorage.getItem('huawei_oauth_state');
        // if (state !== savedState) {
        //   throw new Error('State参数验证失败');
        // }

        // 调用后端接口进行华为登录
        const data = await this.loginWithHuaweiCode(code);

        // 判断是否已关联
        if (data && data.accessToken) {
          // 已关联 - 直接登录成功
          this.$message.success('登录成功');
          this.loginSuccessHandle(data);
        } else {
          // 未关联 - 显示关联选择弹窗
          this.hwUserInfo = data;
          this.relationVisible = true;
          this.btnLoading = false;
        }
      } catch (error) {
        console.error('华为登录回调处理失败:', error);
        this.errorMsg = (error && (error.message || error.msg)) || '登录失败，请重试';
        this.btnLoading = false;
      } finally {
        sessionStorage.removeItem('huawei_oauth_state');
      }
    },

    /**
     * 使用华为授权码调用后端登录接口
     */
    async loginWithHuaweiCode (code) {
      try {
        const res = await this._get({
          url: '/userLogin/hwCallback',
          params: {
            code: code,
            state: 'housekeeperApp-housekeeperApp'
          }
        });

        if (res && res.data) {
          const { accessToken, refreshToken, userId, userName, nickName } = res.data;

          // 如果有 accessToken，说明已关联，保存登录信息
          if (accessToken) {
            localStorage.setItem('refreshToken', refreshToken);
            Common.setToken(accessToken);

            // 保存用户信息
            store.commit('setUserInfo', {
              uid: userId,
              userName: userName,
              nickName: nickName
            });
          }

          // 返回完整数据，让调用方判断是否已关联
          return res.data;
        } else {
          throw new Error('登录接口返回数据异常');
        }
      } catch (error) {
        console.error('华为登录接口调用失败:', error);
        throw new Error((error && (error.msg || error.message)) || '登录失败，请重试');
      }
    },

    /**
     * 登录成功处理
     */
    loginSuccessHandle (data) {
      // 如果是 'communityApp' (即appType=3) 走新路径/pages/login，否则走老路径/pages/loginInfo/login
      const path = PLAT_TYPE === 'communityApp' ? '/pages/login' : '/pages/loginInfo/login';
      const url = `${path}?type=1&&token=${data.accessToken}&&refreshToken=${data.refreshToken}`;
      wx.miniProgram.redirectTo({ url });
      console.info('跳转目标对象1005', url);
    },

    /**
     * 登录已有账号
     */
    loginByAccount () {
      this.relationVisible = false;
      this.relationAccount = true;
      this.operateType = 'pwdLogin';
    },

    /**
     * 创建新账号
     */
    createAccount () {
      this.relationVisible = false;
      this.relationAccount = true;
      this.operateType = 'isRegister';
      this.registerStep = 1;
    },

    /**
     * 提交密码登录（关联已有账号）
     */
    submitPwdLogin () {
      this.$refs.pwdLoginForm.validate().then((res) => {
        this.btnLoading = true;
        const { username, password } = res;

        this._post({
          url: '/userLogin/login',
          params: {
            username,
            password: MD5(password).toString(),
            appId: APP_ID,
            appSecret: APP_SECRET
          }
        }).then(({ data }) => {
          // 登录成功，保存token和用户信息
          localStorage.setItem('refreshToken', data.refreshToken);
          Common.setToken(data.accessToken);
          store.commit('setUserInfo', { uid: data.userId });

          // 显示关联确认弹窗
          this.allocated = true;
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },

    /**
     * 显示注册验证码弹窗
     */
    showNewVerify () {
      this.$refs.registerForm.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newVerify.show();
        }, 100);
      });
    },

    /**
     * 获取注册验证码
     */
    reqSmsCode (verification) {
      this.showVerity = false;
      const { captchaVerification } = verification;
      this.$refs.registerForm.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 4, captchaVerification).then((res) => {
          if (res === 30011) {
            this.registerState.phone = '';
            this.operateType = 'pwdLogin';
          }
        });
      });
    },

    /**
     * 提交注册（第一步）
     */
    register () {
      this.$refs.registerForm.validate(['phone', 'smscode', 'agreement']).then((res) => {
        this.btnLoading = true;
        this._post({
          url: '/user/registerByPhone',
          params: {
            phone: res.phone,
            smscode: res.smscode,
            platType: PLAT_TYPE,
            fromOs: FROM_OS
          }
        }).then(({ data }) => {
          this.registerStep = 2;
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },

    /**
     * 设置密码（第二步）
     */
    setPassword () {
      this.$refs.registerForm.validate().then((res) => {
        this.btnLoading = true;
        const { newPassword, confirmPassword } = res;
        // 使用第一步保存的手机号
        const phone = this.registerState.phone;

        // 如果是关联华为账号的注册流程，使用带登录的接口
        if (this.relationAccount === true) {
          this._post({
            url: '/user/updatePwdByPhone/login',
            params: {
              phone,
              newPassword: MD5(newPassword).toString(),
              confirmPassword: MD5(confirmPassword).toString(),
              appId: APP_ID,
              appSecret: APP_SECRET
            }
          }).then(({ data }) => {
            // 注册成功并自动登录
            localStorage.setItem('refreshToken', data.refreshToken);
            Common.setToken(data.accessToken);
            store.commit('setUserInfo', { uid: data.userId });

            // 标记为注册时关联华为
            this.isRegisterBindHw = 1;

            // 自动关联华为账号
            this.handleRelate();
          }).catch(() => {
            this.btnLoading = false;
          });
        } else {
          // 一般注册流程，使用不带登录的接口
          this._post({
            url: '/user/updatePwdByPhone',
            params: {
              phone,
              newPassword: MD5(newPassword).toString(),
              confirmPassword: MD5(confirmPassword).toString()
            }
          }).then(({ data }) => {
            this.$message.success('注册成功');
            this.registerStep = 3;
            this.btnLoading = false;
          }).catch(() => {
            this.btnLoading = false;
          });
        }
      });
    },

    /**
     * 确认关联华为账号
     */
    handleRelate () {
      const userId = computed(() => store.state.userInfo.uid);
      this.btnLoading = true;

      this._post({
        url: '/user/hwBindUser',
        params: {
          userId: userId.value,
          unionid: this.hwUserInfo.unionid,
          openId: this.hwUserInfo.openId,
          ssoType: 'hw_house_app',
          isRegisterBindHw: this.isRegisterBindHw
        }
      }).then(({ data }) => {
        this.$message.success('关联成功');
        this.isRegisterBindHw = 0;

        // 如果是注册流程，显示完成页面
        if (this.operateType === 'isRegister') {
          this.registerStep = 3;
          this.btnLoading = false;
        } else {
          // 否则直接跳转
          const accessToken = Common.getToken();
          const refreshToken = localStorage.getItem('refreshToken');
          this.loginSuccessHandle({ accessToken, refreshToken });
        }
      }).catch(() => {
        this.btnLoading = false;
      });
    },

    /**
     * 取消关联，直接进入应用
     */
    cancelRelate () {
      this.$message.success('登录成功');
      // 获取当前已登录的用户信息和token
      const accessToken = Common.getToken();
      const refreshToken = localStorage.getItem('refreshToken');
      this.loginSuccessHandle({ accessToken, refreshToken });
    },

    /**
     * 获取手机验证码(图形验证) - 手机号登录
     */
    showNewPLVerify () {
      this.$refs.phoneLoginForm.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showPLVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newPLVerify.show();
        }, 100);
      });
    },

    /**
     * 获取手机验证码(手机号登录)
     */
    phoneLoginGetCode (verification) {
      this.showPLVerity = false;
      const { captchaVerification } = verification;
      this.$refs.phoneLoginForm.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 3, captchaVerification);
      });
    },

    /**
     * 提交登录（手机号登录）
     */
    submitPhoneLogin () {
      this.$refs.phoneLoginForm.validate().then((res) => {
        this.btnLoading = true;
        this._post({
          url: '/userLogin/smsLogin',
          params: {
            ...this.phoneState,
            appId: APP_ID,
            appSecret: APP_SECRET,
            fromOs: FROM_OS
          }
        }).then(({ data }) => {
          // 登录成功，保存token和用户信息
          localStorage.setItem('refreshToken', data.refreshToken);
          Common.setToken(data.accessToken);
          store.commit('setUserInfo', { uid: data.userId });

          // 显示关联确认弹窗
          this.allocated = true;
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },

    /**
     * 获取验证码（图形验证） - 忘记密码
     */
    showNewFPVerify () {
      this.$refs.forgetForm.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showFPVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newFPVerify.show();
        }, 100);
      });
    },

    /**
     * 获取验证码（忘记密码）
     */
    forgetGetCode (verification) {
      this.showFPVerity = false;
      const { captchaVerification } = verification;
      this.$refs.forgetForm.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 0, captchaVerification);
      });
    },

    /**
     * 验证验证码(忘记密码)
     */
    forgetPwdNext () {
      this.$refs.forgetForm.validate(['phone', 'smscode']).then((res) => {
        this.btnLoading = true;
        this._post({
          url: '/userLogin/checkCode',
          params: {
            ...this.forgetState,
            type: 0, // 0：忘记密码
            platType: PLAT_TYPE
          }
        }).then(({ data }) => {
          this.forgetStep = 2;
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },

    /**
     * 提交（忘记密码）
     */
    submitForgetPwd () {
      this.$refs.forgetForm.validate().then((res) => {
        this.btnLoading = true;
        let data = {...this.forgetState };
        data.newPassword = MD5(data.newPassword).toString();
        data.confirmPassword = MD5(data.confirmPassword).toString();
        this._post({
          url: '/user/forgetPassword',
          params: data
        }).then(({ data }) => {
          this.$message.success('修改成功');
          this.forgetStep = 1;
          this.operateType = 'pwdLogin';
          // 重置忘记密码表单
          this.forgetState = {
            phone: '',
            smscode: '',
            newPassword: '',
            confirmPassword: ''
          };
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },

    /**
     * 返回登录
     */
    backLogin () {
      // 重置所有状态
      this.operateType = 'huaweiAuth';
      this.registerStep = 1;
      this.forgetStep = 1;
      this.relationAccount = false;
      this.relationVisible = false;
      this.allocated = false;

      // 重置表单数据
      this.registerState = {
        phone: '',
        smscode: '',
        agreement: false,
        newPassword: '',
        confirmPassword: ''
      };
      this.formState = {
        username: '',
        password: ''
      };
      this.phoneState = {
        phone: '',
        smscode: ''
      };
      this.forgetState = {
        phone: '',
        smscode: '',
        newPassword: '',
        confirmPassword: ''
      };
    }

  }
});
</script>

<style lang="scss" scoped>
.huawei-login {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .form-box {
    width: 100%;
    max-width: 400px;
    background: white;
    border-radius: 12px;
    padding: 40px 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      text-align: center;
      margin-bottom: 40px;

      &.guide-title {
        margin-bottom: 12px;
      }
    }

    .to-register {
      text-align: center;
      margin-bottom: 32px;
      font-size: 14px;

      .text-1 {
        color: #666;
      }

      .text-2 {
        color: #1890ff;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .login-form {
      .huawei-logo {
        text-align: center;
        margin-bottom: 40px;

        img {
          width: 80px;
          height: 80px;
        }
      }

      .ant-form-item {
        margin-bottom: 20px;
      }

      .remember {
        margin-bottom: 24px;

        .remember-pwd {
          color: #666;
        }
      }

      .sms-code {
        color: #999;
        font-size: 14px;
      }

      .fetch-code {
        color: #1890ff;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          text-decoration: underline;
        }
      }

      .agree {
        color: #666;
        font-size: 12px;
      }

      .user-agree {
        color: #1890ff;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .button {
        width: 100%;
        height: 48px;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &.huawei-button {
          background: linear-gradient(135deg, #ff0000 0%, #d50000 100%);
          color: white;

          &:hover:not(:disabled) {
            background: linear-gradient(135deg, #e60000 0%, #c00000 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }

        .icon-loading {
          font-size: 18px;
        }
      }

      .tips {
        margin-top: 16px;
        text-align: center;

        .error-text {
          color: #ff4d4f;
          font-size: 14px;
        }
      }

      .reg-finish {
        text-align: center;
        padding: 20px 0;

        .icon-box {
          margin-bottom: 20px;

          .icon {
            width: 64px;
            height: 64px;
          }
        }

        .reg-finish-tip {
          font-size: 16px;
          color: #333;
          margin-bottom: 24px;
        }

        .button {
          width: 100%;
          height: 48px;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s;
          border: none;
          background: #1890ff;
          color: white;

          &:hover {
            background: #40a9ff;
          }

          &.button-plain {
            background: white;
            color: #1890ff;
            border: 1px solid #1890ff;

            &:hover {
              background: #f0f7ff;
            }
          }
        }
      }

      .other {
        padding: 0 16px;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        list-style: none;

        .text {
          color: #abb2bd;
          font-size: 14px;
          line-height: 14px;
          cursor: pointer;

          &:hover {
            color: #1890ff;
          }
        }
      }
    }
  }

  // 关联账号弹窗样式
  .modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 24px;
  }

  .avatar {
    text-align: center;
    padding: 20px 0;

    .pic-box {
      width: 80px;
      height: 80px;
      margin: 0 auto 16px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #f0f0f0;

      .pic {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .name {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }

    .text {
      font-size: 14px;
      color: #666;
    }
  }

  .btn-box {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;

    .ant-btn {
      height: 44px;
      font-size: 15px;
      border-radius: 8px;
    }
  }
}

@media (max-width: 480px) {
  .huawei-login {
    padding: 0;

    .form-box {
      border-radius: 0;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}
</style>
